"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsages = void 0;
const routes_1 = require("../../routes");
const getUsages = (client) => async (query) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_USAGES.path, {
        params: query,
    });
    return response.data;
};
exports.getUsages = getUsages;
